import { normalizeBattleRoomId, type BattleRoom } from 'features/battle/room';

const roomUrl = (id: string): string => `/.netlify/functions/battle-room?id=${encodeURIComponent(id)}`;

export const fetchBattleRoom = async (id: string): Promise<BattleRoom | null> => {
  const roomId = normalizeBattleRoomId(id);
  if (!roomId) return null;
  const response = await fetch(roomUrl(roomId), { cache: 'no-store' });
  if (response.status === 404) return null;
  if (!response.ok) throw new Error(`Failed to load battle ${roomId}`);
  return (await response.json()) as BattleRoom;
};

export class BattleRoomConflictError extends Error {
  readonly room: BattleRoom;

  constructor(room: BattleRoom) {
    super('Battle room write was stale');
    this.name = 'BattleRoomConflictError';
    this.room = room;
  }
}

export const putBattleRoom = async (room: BattleRoom, options?: { keepalive?: boolean }): Promise<void> => {
  const response = await fetch(roomUrl(room.id), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(room),
    keepalive: options?.keepalive,
  });
  if (response.status === 409) {
    const body = (await response.json().catch(() => null)) as { room?: BattleRoom } | null;
    if (body?.room) throw new BattleRoomConflictError(body.room);
  }
  if (!response.ok) throw new Error(`Failed to save battle ${room.id}`);
};
